// this file is generated by update_shopify_store_data.py at 2026-06-22 20:27:57.699951
var courses = [
    {
        "course_id": "4B0AB12E-55B9-EF11-99A4-005056A7C6AF",
        "course_version": 1,
        "name": "ANA: APRN Pharmacology Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "ANA\u2019s APRN Pharmacology Bundle provides you with opportunity to earn 33.10 pharmacology contact hours in one easy-to-access bundle! You get 8 APRN Pharmacology courses to help you fulfill ANCC\u2019s requirement for 25 contact hours of pharmacotherapeutics as a portion of the mandatory 75 contact hours in the CNS or NP field.\r\n\u211e Earn 33.10 pharmacology contact hours upon completion of all courses.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "477E659A-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Curricula",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "8B9091EE-4986-EE11-9987-005056A725AD",
                "course_version": 1,
                "name": "ANA: APRN Pharmacology Today: Dementia",
                "course_type": 1,
                "author_information": "",
                "description": "Overview\r\n\r\nThis course offers the APRN a broad overview of how to safely manage patients with dementia using pharmacologic agents and nonpharmacologic interventions. This course assists the APRN in fulfilling pharmacology CNE requirements for licensure.\r\n\r\nCourse Modules Include:\r\nIntroduction to Dementia\r\nTypes of Dementia\r\nNonpharmacological Interventions for Dementia\r\nMedications for the Treatment of Dementia",
                "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Define dementia and describe its prevalence</li>\r\n    <li>Describe the tools used to assess cognitive impairment</li>\r\n    <li>Distinguish between the types of dementia by describing the associated clinical features and pathophysiology</li>\r\n    <li>Describe nonpharmacological interventions for dementia</li>\r\n    <li>Compare and contrast the pharmacologic agents used for the management of dementia-associated cognitive symptoms</li>\r\n    <li>Discuss the role of antipsychotics for treatment of dementia-related agitation and psychosis</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                        "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Anesthetist",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 3.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "64FB86E1-4A86-EE11-9987-005056A725AD",
                "course_version": 1,
                "name": "ANA: APRN Pharmacology Today: Heart Failure",
                "course_type": 1,
                "author_information": "",
                "description": "Overview\r\n\r\nThis course offers the APRN a broad overview of how to safely manage patients with heart failure using pharmacologic agents and non-pharmacologic interventions. This course assists the APRN in fulfilling pharmacology CNE requirements for licensure.",
                "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Describe risk factors and diagnostic criteria for heart failure</li>\r\n    <li>Compare and contrast the available pharmacologic treatments for heart failure</li>\r\n    <li>Review current literature and guideline recommendations for the treatment of heart failure</li>\r\n    <li>Formulate a treatment and monitoring plan for a patient with heart failure to decrease complications in the general population and subpopulations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "A1077672-4B86-EE11-9987-005056A725AD",
                "course_version": 1,
                "name": "ANA: APRN Pharmacology Today: Polypharmacy Considerations",
                "course_type": 1,
                "author_information": "",
                "description": "Overview\r\n\r\nThis course offers the APRN an overview of polypharmacy, the concerns related to polypharmacy, and how to address the overall impact of polypharmacy, especially when considering the older adult and geriatric populations. This course assists the APRN in fulfilling pharmacology CE requirements for licensure.",
                "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Describe polypharmacy and the impact of polypharmacy on older adults</li>\r\n    <li>Discuss key aspects of BEERS criteria and application to practice</li>\r\n    <li>Explore different tools and resources do decrease inappropriate medication prescribing</li>\r\n    <li>Identify one practice change based on current course content</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Anesthetist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                        "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "02064EC2-15DD-E311-AD18-005056B141CC",
                        "course_category_name": "Medications",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 3.6,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "90DD16F2-4B86-EE11-9987-005056A725AD",
                "course_version": 1,
                "name": "ANA: APRN Pharmacology Today: Safe Medication Use in Older Adults with Cardiovascular Disease",
                "course_type": 1,
                "author_information": "",
                "description": "Overview\r\nThis APRN Pharmacology Today course provides an introduction to the pitfalls of medication use in older adults with cardiovascular disease, including pharmacologic changes and potential inappropriate medication use. The course focuses on current evidence-based clinical practice guidelines, standards of care, and treatment options to safely prescribe and manage chronic cardiovascular disease in older adult patients.",
                "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Review current literature and guideline recommendations for the safe use of medications in older adults</li>\r\n    <li>Compare and contrast the available pharmacologic treatments that ensure safe use of medications in older adults</li>\r\n    <li>Formulate a treatment and monitoring plan for safe use of medications in older adults using case studies</li>\r\n    <li>And much more!</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                        "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Anesthetist",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 3.25,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "8F318487-4C86-EE11-9987-005056A725AD",
                "course_version": 2,
                "name": "ANA: APRN Pharmacology Today: Safe Prescribing of Opioids",
                "course_type": 1,
                "author_information": "",
                "description": "Designed to fulfill the new DEA requirements, this comprehensive course will provide you with essential knowledge and evidence-based guidance for safe opioid prescribing. Using an interactive, asynchronous format, you will cover the following topics: \r\n\r\n\u2022\tTopic 1. Introduction to Opioids and Prescribing Regulations \r\n\u2022\tTopic 2. Pain Pathways and Opioid Physiology \r\n\u2022\tTopic 3. Pain Assessment and Management \r\n\u2022\tTopic 4. Nonopioid Pain Management \r\n\u2022\tTopic 5. Opioid Pharmacotherapy and Safe Prescribing Practices \r\n\u2022\tTopic 6. Opioid Use Disorder and Associated Risks \r\n\u2022\tTopic 7. Emerging Trends",
                "learning_objectives_html": "<h2>Key Learning Objectives</h2>\r\n<ul>\r\n    <li>Apply DEA\u2011compliant principles for pain assessment, diagnosis, and safe opioid prescribing.</li>\r\n    <li>Integrate pharmacologic and nonpharmacologic therapies to optimize patient\u2011centered pain management.</li>\r\n    <li>Implement evidence\u2011based strategies to prevent, identify, and manage opioid use disorder, overdose, and withdrawal.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Anesthetist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                        "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
                    "course_level_accreditation_statement": "8.0 Contact Hours\r\n<br />\r\n4.0 Pharmacology Hours",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 8.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2FDCC152-8488-EE11-9987-005056A725AD",
                "course_version": 1,
                "name": "ANA: APRN Pharmacology Today: Understanding Herbal, Vitamin, and Mineral Supplements",
                "course_type": 1,
                "author_information": "",
                "description": "Overview\r\nYou will focus on the efficacy, safety, and drug interactions of the most used vitamins, over-the-counter products, and herbal supplements in this course. Advanced Practice Registered Nurses (APRN) like you will also benefit from a review of key drug-food interactions, how to evaluate sources for best practice guidelines, and differentiate key issues pertaining to special populations. You will also gain insight into methods of interviewing patients to get an accurate account of their vitamin and supplement use.",
                "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Appraise the most commonly used herbal supplements and vitamins in the United States</li>\r\n    <li>Analyze the efficacy, safety, and drug interactions of common vitamins, over-the-counter medications, and herbal supplements</li>\r\n    <li>Apply components of patient counseling to secure key information from patients regarding vitamins, over-the-counter medications, and herbal supplements</li>\r\n    <li>Differentiate key issues pertaining to special populations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                        "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Anesthetist",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 4.5,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "AFCE3927-AA42-EF11-998E-005056A7F31D",
                "course_version": 1,
                "name": "ANA: APRN Pharmacology Today: Understanding Treatment of Bipolar Disorder",
                "course_type": 1,
                "author_information": "",
                "description": "Overview: \r\nThis course explores the pharmacologic options for treating bipolar disorder (including bipolar I and bipolar II). It outlines the pharmacotherapeutic principles of the various modalities, with comparative analysis of efficacy and adverse effects and attention to special patient populations. In reviewing the evidence-based guidance and case studies, you will gain comprehensive insight into tailoring pharmacologic approaches to each patient given the unique challenges presented by bipolar disorder.",
                "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    Describe the diagnostic criteria for bipolar and related disorders.\r\n    <br />\r\n    Apply the latest evidence and guideline recommendations on bipolar disorder to the pharmacologic treatment of individuals diagnosed with the disorder.<br />\r\n    Compare and contrast the pharmacologic treatments for bipolar disorder, considering pharmacokinetics, pharmacodynamics, and pharmacotherapeutics.\r\n    <br />\r\n    Formulate treatment and monitoring plans, integrating effective pharmacologic interventions for individuals exhibiting symptoms of bipolar disorder.\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Anesthetist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DE16FFD5-752E-11DD-8D4B-000423AF2193",
                        "course_category_name": "Psychologist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                        "course_category_name": "Psychiatric Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                        "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 6.75,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "8B2FF1C4-B542-EF11-998E-005056A7F31D",
                "course_version": 1,
                "name": "ANA: APRN Pharmacology Today: Pharmacotherapy of Diabetes Mellitus",
                "course_type": 1,
                "author_information": "",
                "description": "Overview: \r\nThis course explores the latest advancements in drug therapies for treating diabetes mellitus. It outlines the pharmacotherapeutic principles of the various modalities, with comparative analysis of efficacy and adverse effects and attention to special patient populations. In reviewing the evidence-based guidance and case studies, you will gain comprehensive insight into tailoring pharmacologic approaches to each patient to optimize treatment given the unique challenges presented by diabetes mellitus.",
                "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>Apply the latest evidence and guideline recommendations on diabetes mellitus to the pharmacologic treatment of individual's diagnosed with this disorder.\r\n    <br />\r\n    Compare and contrast the pharmacologic treatments for diabetes mellitus, considering pharmacokinetics, pharmacodynamics, and pharmacotherapeutics.\r\n    <br />\r\n    Formulate treatment and monitoring plans, integrating effective pharmacologic interventions for individuals exhibiting symptoms of diabetes mellitus.\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Anesthetist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pharmacology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                        "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                        "course_category_name": "ANA - American Nurses Association",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "ANCC",
                    "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "ANCC CNE Credit",
                    "credit_units": 2.0,
                    "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];